import i18next from 'i18next';

import { AuditLogsRowData, PageQueryOptions } from '@breathelife/types';

import { notificationSlice } from '../../ReduxStore/Notification/NotificationSlice';
import { Dispatch } from '../../ReduxStore/types';
import ApiService from '../../Services/ApiService';
import { auditLogsSlice } from './AuditLogsSlice';

export const fetchAuditLogs =
  (
    query: { resourceName?: string; resourceId?: string; actionType?: string },
    queryOptions: PageQueryOptions<AuditLogsRowData>,
  ) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(auditLogsSlice.actions.setIsLoading({ isLoading: true }));

    try {
      const response = await ApiService.fetchAuditLogs(query, queryOptions);
      const { data: logs, total } = response.data;

      dispatch(auditLogsSlice.actions.setLogs({ logs, total }));
    } catch (error: any) {
      const entity = i18next.t('admin.auditLogs.logEntity.plural');
      notificationSlice.actions.setError({
        message: i18next.t('notifications.failedToFetchEntity', { entity }),
      });
    } finally {
      dispatch(auditLogsSlice.actions.setIsLoading({ isLoading: false }));
    }
  };
